import type { SlideImage } from '@/app/[locale]/about-us/_components/ImagesSlideOverOnScroll';

const SLIDE_IMAGES: SlideImage[] = [
  {
    path: 'about-us/solutions-carousel-01@2x',
    alt: 'about_us_secondary_alt_1',
    format: 'jpg',
  },
  {
    path: 'about-us/solutions-carousel-02@2x',
    alt: 'about_us_secondary_alt_2',
    format: 'jpg',
  },
  {
    path: 'about-us/solutions-carousel-04@2x',
    alt: 'about_us_secondary_alt_3',
    format: 'jpg',
  },
];

export default SLIDE_IMAGES;
